<template>
  <PageHeader :showBreadcrumb="true" />
  <div>
    <p>&bull; MDH is providing this fillable form in order to collect information from you about why you are filing an external appeal, HMO complaint, No Surprises Act complaint, or quality of care complaint. MDH intends to use the information you provide for investigation of your appeal or complaint, which may include collecting information from your HMO and provider(s), and, for external appeals only, delivering the data you provide to an Independent Review Organization that has contracted with MDH to review external appeals (“IRO”).  </p>
    <p>&bull; You are not legally required to provide any data to MDH and you may refuse to provide data. However, if you do not provide the requested data, no investigation or review will occur and no action will take place with respect to your appeal or complaint.  </p>
    <p>&bull; If you provide the requested data, your data will be used by MDH to investigate your complaint or by an IRO to review your external appeal. Data you provide may also be used in an action MDH brings against an HMO. </p>
    <p>&bull; The data you provide may be disclosed to MDH staff whose job(s) requires them to access the appeal or complaint material, Independent Review Organizations who have contracted with MDH to review external appeals, other Minnesota state agencies that have legal authorization to obtain the data, the Minnesota Attorney General’s office, the state or legislative auditor, or anyone MDH is directed by court order to provide it to. </p>
  </div>
  <div>
    <button class="btn btn-primary" @click="goToExternalAppealForm">Next</button>
  </div>
</template>

<script setup>
import PageHeader from "@/components/common/PageHeader.vue";
</script>
<script>
export default {
  methods: {
    goToExternalAppealForm() {
      this.$router.push('/appealsAndComplaints/ExternalAppealForm');
    }
  }
};
</script>

<style scoped>
.tx-p {
  padding: 1.5rem;
  height: 200px;
}
</style>